/**
 * 2019-04-09
 * handan
 * 获取充值类型
 */

import { ajax } from "../utils/http/http";
import handleError from "../utils/handleError";

// 获取充值列表
const getRechargeList = async ()=>{
  let data = await ajax("/58/recharge/list");
  if(data.code==="1"){
    return Promise.resolve(data.data)
  }else{
    return handleError(data);
  }
}

// 充值接口
const chargeAndPay = async (params)=>{
  let data = await ajax("/58/recharge/chargeAndPay","POST",params)
  if(data.code==="1"){
    return Promise.resolve(data.data)
  }else{
    return handleError(data);
  }
}

export {
  getRechargeList,
  chargeAndPay,
} 